"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _preact = require("preact");

var _axios = _interopRequireDefault(require("axios"));

var _renderProps = require("../../libs/renderProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Fetch = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Fetch, _Component);

  var _super = _createSuper(Fetch);

  function Fetch() {
    var _this;

    (0, _classCallCheck2.default)(this, Fetch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mounted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: false,
      items: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetch", (0, _debounce.default)(function () {
      if (!_this.mounted) return;
      var _this$props = _this.props,
          baseUrl = _this$props.baseUrl,
          searchValue = _this$props.searchValue,
          onLoaded = _this$props.onLoaded,
          responseKey = _this$props.responseKey,
          customFetch = _this$props.customFetch;
      var url = "".concat(baseUrl).concat(searchValue);

      if (customFetch) {
        customFetch(searchValue, url, responseKey !== null && responseKey !== void 0 ? responseKey : '').then(function (items) {
          if (_this.mounted) {
            onLoaded(items);

            _this.setState({
              loading: false,
              items: items
            });
          }
        });
      } else {
        _axios.default.get(url).then(function (response) {
          var items = responseKey ? response.data[responseKey] : response.data;

          if (_this.mounted) {
            onLoaded(items);

            _this.setState({
              loading: false,
              items: items
            });
          }
        });
      }
    }, 300));
    return _this;
  }

  (0, _createClass2.default)(Fetch, [{
    key: "prepareFetch",
    value: function prepareFetch() {
      // eslint-disable-next-line react/no-access-state-in-setstate
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        loading: true
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.prepareFetch();
      this.fetch();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.searchValue !== this.props.searchValue) {
        this.prepareFetch();
        this.fetch();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var state = this.state;
      return (0, _renderProps.extractRenderPropsChildren)(props.children)(state);
    }
  }]);
  return Fetch;
}(_preact.Component);

exports.default = Fetch;